import { render, staticRenderFns } from "./CohortInstructorsPage.vue?vue&type=template&id=a530cd8a&scoped=true"
import script from "./CohortInstructorsPage.vue?vue&type=script&lang=js"
export * from "./CohortInstructorsPage.vue?vue&type=script&lang=js"
import style0 from "./CohortInstructorsPage.vue?vue&type=style&index=0&id=a530cd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530cd8a",
  null
  
)

export default component.exports